import { memo } from "react";
import PropTypes from "prop-types";
import "./activity.scss";
import ProgressiveImg from "app/pages/.shared/ProgressiveImg";
import Paragraphs from "app/pages/.shared/Paragraphs";
import { photoPropTypes } from "app/utils/propTypes";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const ACTIVITY_MEDIA_SIZES = {
	small: { width: 768 },
	medium: { width: 978 },
	large: { height: 208, width: 581 },
	xlarge: { height: 208, width: 581 },
};

const Activity = ({ label, paragraphs = [], photo = {} }) => {
	return (
		<div className="activity">
			<Typography
				variant={TYPOGRAPHY_VARIANTS.LARGE}
				isBold
				className="activity__label"
				component="h3"
			>
				{label}
			</Typography>

			{photo.url && (
				<div className="activity__image">
					<ProgressiveImg
						sizes={ACTIVITY_MEDIA_SIZES}
						src={photo.url}
						alt={photo.alt}
						thumbnail={photo.thumbnail}
					/>
				</div>
			)}

			<div className="activity__intro">
				<Paragraphs paragraphs={paragraphs} enableHTMLFormatting={true} />
			</div>
		</div>
	);
};

Activity.propTypes = {
	label: PropTypes.string,
	paragraphs: PropTypes.arrayOf(PropTypes.string),
	photo: photoPropTypes,
};

export default memo(Activity);
